import { Component, createContext, lazy, Suspense, useCallback, useContext, useEffect, useRef, useState } from 'react';
import Brand from './Brand';
import WorkspaceDialog from './WorkspaceDialog';
import './secret-logo.css';

const MarketRunner = lazy(() => import('./MarketRunner'));
const LogoContext = createContext(() => false);
const TAP_WINDOW = 2200;

class RunnerBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    return this.state.failed
      ? <WorkspaceDialog title="Market Runner" onClose={this.props.onClose}><p className="tl-runner-load">The game couldn’t load. Close this window and refresh TradeLog to try again.</p></WorkspaceDialog>
      : this.props.children;
  }
}

export function LogoEasterEggProvider({ children }) {
  const streak = useRef({ count: 0, last: 0 });
  const opener = useRef(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open && opener.current) {
      if (opener.current.isConnected) opener.current.focus();
      opener.current = null;
    }
  }, [open]);
  const tap = useCallback(event => {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return false;
    if (document.querySelector('[aria-modal="true"], [data-tl-navigation-dialog]')) {
      streak.current = { count: 0, last: 0 };
      return false;
    }
    const now = Date.now(), previous = streak.current;
    const count = now - previous.last <= TAP_WINDOW ? previous.count + 1 : 1;
    streak.current = { count, last: now };
    if (count < 5) return false;
    streak.current = { count: 0, last: 0 };
    event.preventDefault();
    opener.current = event.currentTarget;
    setOpen(true);
    return true;
  }, []);
  const close = useCallback(() => setOpen(false), []);
  return <LogoContext.Provider value={tap}>
    {children}
    {open && <RunnerBoundary onClose={close}><Suspense fallback={<WorkspaceDialog title="Market Runner" onClose={close}><p className="tl-runner-load" role="status">Opening a little detour…</p></WorkspaceDialog>}><MarketRunner onClose={close}/></Suspense></RunnerBoundary>}
  </LogoContext.Provider>;
}

// Only navigation logos use this control; branding on exports stays purely visual.
export default function EasterEggLogo({ href, onClick, size = 26, compact = false, className = '', ...props }) {
  const tap = useContext(LogoContext);
  const Tag = href ? 'a' : 'button';
  return <Tag {...props} {...(href ? { href } : { type: 'button' })} className={`tl-secret-logo ${className}`} aria-label={props['aria-label'] || 'TradeLog home'} onClick={event => { if (!tap(event)) onClick?.(event); }}>
    <Brand size={size} compact={compact}/>
  </Tag>;
}
